export default __webpack_public_path__ + "static/media/iPhoneX1.4c2978fb.png";